import { LanguageContext } from 'context/LanguageContext'
import React, { useContext } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import ReOrderAlertBackground from '../../../assets/images/alert_background.svg'
import ReOrderAlert from '../../../assets/images/alert_reorder.svg'
import CloseIcon from '@mui/icons-material/Close'
import { showReOrderErrorMsg } from 'modules/orders/actions'

const ReOrderAlertMessage = () => {
    const { strings } = useContext(LanguageContext)
    const dispatch = useDispatch()
    const showReOrderErrorMsgFlag = useSelector(state => state.orders.get('showReOrderErrorMsg'))

    if(!showReOrderErrorMsgFlag) return
  return (
    <div className='custom_reorder_msg_container container'>
        <div className='custom_reorder_msg'>
              <div
                  className='custom_reorder_msg_close'
                  onClick={()=>dispatch(showReOrderErrorMsg(false))}
              >
                  <CloseIcon fontSize="small" />
              </div>
            <div className='icon'>
                <img src={ReOrderAlertBackground} className='image_background'/>
                <img src={ReOrderAlert} className='image'/>
            </div>
            <span>
                {strings.reOrderAlertMsg1}
                <strong>{strings.reOrderAlertMsg2}</strong>
                {strings.reOrderAlertMsg3}
            </span>
        </div>
    </div>
  )
}

export default ReOrderAlertMessage